import ProfileCard from "./ProfileCard";

const ProfileCohortsSection = ({ cohort, readOnly }) => {
  return (
    <ProfileCard title="Cohort" readOnly={readOnly} hideActions>
      <div className="profile-cohort-card">
        <img
          src="/assets/images/Events.png"
          alt="Cohort avatar"
          className="cohort-avatar"
        />

        <div>
          <div className="cohort-name">{cohort?.title || "Not assigned"}</div>

          {cohort?.range && <div className="cohort-meta">{cohort.range}</div>}
        </div>
      </div>
    </ProfileCard>
  );
};

export default ProfileCohortsSection;
